'use client';

import { c as _c } from "react/compiler-runtime";
import { TopNavMobileBar } from '@src/components/TopNavV4/TopNavMobile/TopNavMobileBar';
import { TopNavMobileSlidingPanel } from '@src/components/TopNavV4/TopNavMobile/TopNavMobileSlidingPanel';
export const TopNavMobile = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <nav className="relative overflow-x-clip lg:hidden"><div className="z-50 h-12 w-full bg-bodi-black-text font-medium text-bodi-white"><TopNavMobileBar /></div><TopNavMobileSlidingPanel /></nav>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};